<template>
    <div v-if="visible">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="1200"
        >
            <v-card>
                <v-card-title class="px-3">Schedule Summary</v-card-title>
                <v-divider></v-divider>

                <v-data-table
                        v-if="scheduleData"
                        :headers="headers"
                        :items="scheduleData"
                        class="elevation-0"
                        :items-per-page="5"
                    >
                    <template v-slot:item.status="{ item }"> 
                        <v-icon small v-if="item.resultCode == '000.000.000' || item.resultCode == '100.100.110'" color="success" size="22">
                            mdi-check-circle
                        </v-icon>
                        <v-icon small v-else-if="item.resultCode != '000.000.000' && item.resultCode != '000.200.000' && item.resultCode != null " color="error" size="22">
                            mdi-alert-circle
                        </v-icon>
                        <v-icon small v-else-if="item.resultCode == '000.200.000'" color="success" size="22">
                            mdi-clock
                        </v-icon>
                        <v-icon small v-else-if="item.resultCode == null && item.amount > 0.00" color="primary" size="22">
                            mdi-clock
                        </v-icon>
                        <v-icon small v-else-if="item.resultCode == null && item.amount == 0.00" color="error" size="22">
                            mdi-clock
                        </v-icon>
                    </template>

                    <template v-slot:item.date="{ item }">
                        <v-menu
                            v-if="item.resultCode == null"
                            v-model="dateModal[item.id]"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        ><template v-slot:activator="{ on }" v-bind:item="item">
                            <v-icon small color="primary" size="22" v-on="on" class="mr-2">
                                mdi-calendar-refresh
                            </v-icon>{{ item.date }}
                        </template>
                            <v-date-picker
                                v-model="item.date"
                                @input="dateModal[item.id] = false"
                                @click:date="updateDate(item)"
                                :allowed-dates="allowedDates"
                            ></v-date-picker>
                        </v-menu>
                        <span v-else>
                            <v-icon small color="error" size="22" class="mr-2">mdi-calendar-remove</v-icon>
                            {{ item.date }}
                        </span>
                    </template>

                    <template v-slot:item.amount="{ item }">
                        <v-edit-dialog
                            v-if="item.resultCode == null"
                            :return-value.sync="item.amount"
                            @save="updateAmount(item)"
                            ><v-icon small color="primary" size="22" class="mr-2">
                                mdi-file-edit-outline
                            </v-icon>{{ `${item.currency} ${item.amount}` }}
                            <template v-slot:input>
                                <v-text-field
                                v-model="item.amount"
                                label="Amount"
                                single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>

                        <span v-else>
                            <v-icon small color="error" size="22" class="mr-2">
                                mdi-file-edit-outline
                            </v-icon>{{ `${item.currency} ${item.amount}` }}
                        </span>
                    </template>

                    <template v-slot:item.runningBalance="{ item }">
                        <span v-if="item.runningBalance != null">{{ `${item.currency} ${item.runningBalance.toFixed(2)} `}}</span>
                    </template>

                    <template v-slot:item.arrears="{ item }">
                        <span v-if="item.arrears != null"><b>{{ `${item.currency} ${item.arrears} `}}</b></span>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-btn v-if="!(['000.000.000', '000.200.000', '100.100.110']).includes(item.resultCode) && item.resultCode != null && (cfgChannel == 'MOTO:ECOM' || cfgChannel == 'MOTO' || cfgChannel == 'All')" x-small class="mr-2" rounded color="primary" dark @click="takePayment(item)">Take Payment</v-btn>
                        <v-btn v-if="!(['000.000.000', '000.200.000', '100.100.110']).includes(item.resultCode) && item.resultCode != null && (cfgChannel == 'MOTO:ECOM' || cfgChannel == 'ECOM' || cfgChannel == 'All')" x-small class="mr-2" rounded color="primary" dark @click="sendPayByLink(item)">Send Pay By Link</v-btn>
                        <v-btn v-if="!item.resultCode && item.amount > 0.00" x-small rounded color="primary" dark @click="addPaymentBreak(item)">
                            <v-icon color="white" size="16" class="mr-1">mdi-plus</v-icon>
                            Payment Break
                        </v-btn>
                        <v-btn v-if="!item.resultCode && item.amount == 0.00" x-small rounded color="error" dark @click="removePaymentBreak(item)">
                            <v-icon color="white" size="16" class="mr-1">mdi-minus</v-icon>
                            Payment Break
                        </v-btn>
                    </template>
                </v-data-table>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="$emit('close', false); success = false;">Close</v-btn>
                    <v-btn color="primary" @click="addDate()">Add Date</v-btn>
                </v-card-actions>

                <!-- Add Date -->
                <add-date
                    :visible="dialog2"
                    :scheduleId="scheduleData[0].scheduleId"
                    @close="dialog2 = $event"
                    @updatePayments="updatePayments"
                ></add-date>

                <!-- Payment -->
                <payment
                    :visible="dialog1"
                    :cardData="dialogData1"
                    :paymentData="paymentData1"
                    :client="client"
                    @close="dialog1 = $event"
                    @updatePayments="updatePayments"
                ></payment>
            </v-card>
        </v-dialog>

        <!-- Snackbar  -->
        <v-snackbar
            v-model="snackbar"
            color="primary"
            timeout="3000"
            bottom
            >
            {{ snackbarText }}
        </v-snackbar>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Payment from '@/components/schedules/SchedulePayment.vue';
import AddDate from '@/components/schedules/AddDate.vue';

export default {
    components: {
        'payment': Payment,
        'add-date' : AddDate
    },
    props: {
        visible: Boolean,
        scheduleData: Array,
        client: Object,
        channels: Object,
        cards: Object,
        cfgChannel: String,
    },
    computed: {
        dialog() {
            return this.visible ? true : false;
        },
    },
    data() {
        return {
            headers: [{ text: 'Status', value: 'status', sortable: false, align: 'center' },
                      { text: 'Source', value: 'source', sortable: false, align: 'center' },
                      { text: 'Scheduled Date', value: 'date', sortable: false, align: 'center' },
                      { text: 'Processing Date', value: 'processingTime', sortable: false, align: 'center' },
                      { text: 'Payment ID', value: 'paymentId', sortable: false, align: 'center' },
                      { text: 'Amount', value: 'amount', sortable: false, align: 'center' },
                      { text: 'Running Balance', value: 'runningBalance', sortable: false, align: 'center' },
                      { text: 'Arrears', value: 'arrears', sortable: false, align: 'center' },
                      { text: 'Actions', value: 'actions', sortable: false, align: 'center' }],
            dialog1: false,
            dialog2: false,
            dialogData1: null,
            paymentData1: null,
            dateModal: [],
            date: null,
            snackbar: false,
            snackbarText: null
        }
    },
    methods: {
        allowedDates: val => val >= moment().add('1', 'day').format('YYYY-MM-DD'),
        takePayment(e) {
            this.dialog1 = true;
            this.dialogData1 = this.cards.unarchived;
            this.paymentData1 = e;
        },
        addPaymentBreak(e) {
            axios({
                method: 'post',
                url: 'add-payment-break',
                data: { id: e.id, paymentId: e.paymentId, scheduleId: e.scheduleId, userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    e.amount = '0.00';
                    this.$emit('getSchedules');
                    this.$emit('getClientLog');
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        removePaymentBreak(e) {
            axios({
                method: 'post',
                url: 'remove-payment-break',
                data: { id: e.id, paymentId: e.paymentId, scheduleId: e.scheduleId, userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    e.amount = e.scheduleAmount;
                    this.$emit('getSchedules');
                    this.$emit('getClientLog');
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        updatePayments() {
            this.$emit('updatePayments', { id: this.scheduleData[0].scheduleId });
            this.$emit('getSchedules');
            this.$emit('getClientLog');
        },
        updateDate(e) {
            axios({
                method: 'post',
                url: 'update-schedule-date',
                data: { item: e, userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.$emit('updatePayments', { id: this.scheduleData[0].scheduleId });
                    this.$emit('getSchedules');
                    this.$emit('getClientLog');
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        updateAmount(e) {
            axios({
                method: 'post',
                url: 'update-schedule-amount',
                data: { item: e, userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.$emit('updatePayments', { id: this.scheduleData[0].scheduleId });
                    this.$emit('getSchedules');
                    this.$emit('getClientLog');
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        addDate() {
            this.dialog2 = true;
        },
        sendPayByLink(e) {
            let form = { channel: this.client['crm_config']['ecomChannel'],
                         merchantTransactionId: this.client.merchantCustomerId,
                         email: this.client.email,
                         mobile: this.client.mobile,
                         amount: e.amount,
                         currency: e.currency,
                         autoSend: 1,
                         clientId: this.client.id,
                         scheduleId: e.scheduleId,
                         paymentId: e.paymentId };
            
            axios({
                method: 'post',
                url: 'send-pay-by-link',
                data: { form: form, userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.result = response.data;
                    console.log(this.result);

                    this.snackbarText = 'Pay By Link has been successfully sent.';
                    this.snackbar = true;
                })
                .catch(e => {
                    this.errors.push(e)
                })
        }
    }
}
</script>